import { render, staticRenderFns } from "./costRecord.vue?vue&type=template&id=4387a54b&"
import script from "./costRecord.vue?vue&type=script&lang=js&"
export * from "./costRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports